<template>
  <v-app id="inspire" v-resize="onResize">
    <v-navigation-drawer
      v-model="drawer"
      :width="isMobile ? '100%' : '300px'"
      v-if="logueado"
      absolute
      temporary
    >
      <div v-if="logueado">
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <v-img src="/LogoMegalabs.png"></v-img>
          </v-list-item-avatar>
          <v-list-item-title class="text-center black--text">
            <strong>Sistema de Cobranzas</strong>
          </v-list-item-title>

          <v-btn icon @click.stop="drawer = !drawer"  @click="validarLogin()">
            <v-icon>fa-solid fa-chevron-left</v-icon>
          </v-btn>
        </v-list-item>
        <v-list-item class="px-2">
          <v-list-item-title class="black--text">
            <strong>{{ version }}</strong>
          </v-list-item-title>
        </v-list-item>
        <v-list-item class="text-center primary--text">
          <strong>{{ $store.state.usuario.nombre }}</strong>
        </v-list-item>
      </div>

      <v-list dense>
        <v-list-item :to="{ name: 'Home' }">
          <v-list-item-icon>
            <v-icon>home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Inicio</v-list-item-title>
        </v-list-item>

        <v-list-group
          v-for="item in items"
          :key="item.title"
          v-model="item.active"
          :prepend-icon="item.action"
          v-show="item.rol.includes(obtenerRol)"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="child in item.items"
            :key="child.title"
            :to="child.direccion"
            v-show="child.rol.includes(obtenerRol)"
          >
            <v-list-item-title>{{ child.title }}</v-list-item-title>
            <v-list-item-icon>
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>

        <v-list-item @click="salir()">
          <v-list-item-icon>
            <v-icon>fa-solid fa-right-from-bracket</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Cerrar Sesión</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-card flat>
      <v-system-bar
        v-if="$ENTORNO === 'D' || $ENTORNO === 'T'"
        color="error"
        dark
      >
        <v-icon> fa-solid fa-flask-vial </v-icon>
        <v-spacer></v-spacer>
        {{ $ENTORNO === "T" ? "SITIO DE PRUEBAS" : "SITIO DE DESARROLLO" }}
      </v-system-bar>
      <v-app-bar color="white" dense flat>
        <v-app-bar-nav-icon
          
          color="secondary"
          @click="validarLogin()"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
        <v-toolbar-title class="font-weight-black secondary--text">{{
          this.$store.state.titulo
        }}</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-menu
          v-model="menu"
          bottom
          right
          transition="scale-transition"
          origin="top left"
          v-if="logueado"
        >
          <template v-slot:activator="{ on }">
            <v-chip pill v-on="on" color="grey lighten-4">
              <strong v-if="!isMobile">{{
                $store.state.usuario.nombre
              }}</strong>
              <strong v-else>{{
                iniciales($store.state.usuario.nombre)
              }}</strong>
            </v-chip>
          </template>
          <v-card :max-width="isMobile ? '400px' : '300px'">
            <v-list light>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="primary--text"
                    ><strong>{{
                      $store.state.usuario.nombre
                    }}</strong></v-list-item-title
                  >
                  <v-list-item-subtitle
                    >{{
                      $store.state.usuario.user
                    }}@megalabs.com.bo</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-list>
              <v-list-item @click="salir()">
                <v-list-item-action>
                  <v-icon color="primary"
                    >fa-solid fa-right-from-bracket</v-icon
                  >
                </v-list-item-action>

                <v-list-item-subtitle class="primary--text"
                  >Cerrar Sesión</v-list-item-subtitle
                >
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-app-bar>
    </v-card>
    <!-- VERIFICAMOS SI ESTÁ LOGUEADO Y SI LA RUTA NO ES LOGIN-->
    <v-main v-if="logueado || route === 'Login'">
      <v-container class="fill-height" fluid>
        <v-slide-y-transition mode="out-in">
          
          <router-view />
        </v-slide-y-transition>
      </v-container>
    </v-main>
    <v-main v-else>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card>
              <v-card-title class="text-center primary--text">
                <h1>¡Bienvenido!</h1>
              </v-card-title>
              <v-card-text class="text-center">
                Por favor, inicia sesión para continuar.
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn color="primary" @click="$router.push({ name: 'Login' })">
                  Iniciar Sesión
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-snackbar
      v-for="(snackbar, index) in snackbars.filter((s) => s.showing)"
      :key="snackbar.text + Math.random()"
      v-model="snackbar.showing"
      :timeout="snackbar.timeout"
      :top="true"
      :color="snackbar.color"
      :right="true"
      :style="`top: ${index * 2}px`"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          color="white"
          small
          fab
          text
          dark
          @click="snackbar.showing = false"
        >
          <v-icon>cancel</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>
<style>
td {
  /* font-family: "Arial", Arial, sans-serif !important; */
  font-size: 14px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
}

th {
  background-color: #fff;
  color: #000;
  height: 0px !important;
}

table {
  border-collapse: collapse;
  width: 100%;
  height: 0px !important;
}

table,
th,
td {
  height: 0px !important;
  border: 0.2px solid rgb(236, 233, 233);
}

.theme--light.v-data-table thead tr th {
  text-align: center !important;
  /* vertical-align: middle !important; */
}
</style>

<script>
import { mapState } from "vuex";
import axios from "axios";

export default {
  props: {
    source: String,
  },

  data: () => ({
    gestion: "",
    menu: false,
    dialog: false,
    drawer: null,
    version: "v.1.5.3",
    mini: true,
    isMobile: false,
    route:"",
    itemsSnack: [],
    items: [
      {
        action: "fa-solid fa-file-lines",
        active: true,
        rol: "ADM,COB,REP,ENC",
        items: [
          {
            title: "Clientes",
            direccion: { name: "Cliente" },
            icon: "fa-solid fa-users",
            rol: "COB,REP,ADM",
          },
          {
            title: "Recibos",
            direccion: { name: "Recibo" },
            icon: "fa-solid fa-scroll",
            rol: "COB,REP,ADM,ENC",
          },

          {
            title: "Bancos",
            direccion: { name: "Banco" },
            icon: "fa-solid fa-building-columns",
            rol: "ADM,ENC",
          },

          {
            title: "Talonarios",
            direccion: { name: "Talonario" },
            icon: "fa-solid fa-file-invoice-dollar",
            rol: "ADM,ENC",
          },
        ],
        title: "Gestión de Cobranzas",
      },
      {
        action: "fa-solid fa-file-lines",
        active: true,
        rol: "ADM,ENC,COB",
        items: [
          {
            title: "Métodos de Pago",
            direccion: { name: "MetodoPagoView" },
            icon: "fa-solid fa-money-bill-trend-up",
            rol: "ADM,ENC",
          },

          {
            title: "Reporte de Bancarización",
            direccion: { name: "BancarizacionView" },
            icon: "fa-solid fa-comments-dollar",
            rol: "ADM,ENC",
          },

          {
            title: "Kardex de Bonos",
            direccion: { name: "KardexBonosView" },
            icon: "fa-solid fa-file-invoice-dollar",
            rol: "ADM,ENC,COB",
          },

          {
            title: "Kardex Terbol",
            direccion: { name: "KardexTerbolBonosView" },
            icon: "fa-solid fa-clover",
            rol: "ADM,ENC,COB",
          },
        ],
        title: "Reportes",
      },

      {
        action: "settings",
        active: true,
        rol: "ADM,ENC",
        items: [
          {
            title: "Aprobación de Transferencias",
            direccion: { name: "AprobacionTransferencia" },
            icon: "fa-solid fa-money-check-alt",
            rol: "ADM,ENC",
          },
          {
            title: "Aprobación de Recibos",
            direccion: { name: "AprobacionRecibo" },
            icon: "fa-solid fa-file-circle-check",
            rol: "ADM,ENC",
          },
          {
            title: "Usuario",
            direccion: { name: "Usuario" },
            icon: "fa-solid fa-user",
            rol: "ADM,ENC",
          },
        ],
        title: "Parámetros",
      },
    ],
  }),
  computed: {
    ...mapState(["current user", "snackbars"]),

    logueado() {
      var now = new Date();
      try {
        var expira = this.$store.state.usuario.exp;
        expira = expira* 1000; // Convertir a milisegundos
      } catch {
        var expira = now.getTime();
      }
      
      var nowTimeStamp = now.getTime();
      var diferencia = expira - nowTimeStamp;
      var dif = diferencia <= 0 ? false : true;
      return dif;
    },

    obtenerRol() {
      var rol = "";
      if (this.$store.state.usuario) {
        rol = this.$store.state.usuario.rol;
      }
      return rol;
    },
  },
  mounted() {
    
    this.onResize();
  },

  created() {
    //this.$gtag.pageview('/areaDelPresupuestoPrueba')
    this.route = this.$router.apps[0]._route.name;
    console.log("Ruta actual:", this.route);
    this.$store.dispatch("autoLogin");
  },
  updated() {},
  methods: {
    salir() {
      this.$store.dispatch("salir");
    },

    onResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },
    validarLogin() {
      var now = new Date();
      try {
        var expira = this.$store.state.usuario.exp;
        expira = expira* 1000; // Convertir a milisegundos
      } catch {
        var expira = now.getTime();
      }
      
      var nowTimeStamp = now.getTime();
      var diferencia = expira - nowTimeStamp;
      if (diferencia <= 0) {
        this.salir();
      }     
    },
    iniciales(cadena) {
      var inicial = "";
      var separador = " ";
      var arregloDeSubCadenas = cadena.split(separador);
      var subCadena = "";

      for (var x = 0; x < arregloDeSubCadenas.length; x++) {
        subCadena = arregloDeSubCadenas[x].substring(0, 1);
        inicial = inicial + subCadena + "";
      }
      return inicial;
    },
  },
};
</script>
